// extracted by mini-css-extract-plugin
export default {"main":"InfoPage_main__IxJt-","title":"InfoPage_title__xW3uu","content":"InfoPage_content__XdlaD","footer":"InfoPage_footer__vrvu+","sidebar":"InfoPage_sidebar__qY0KI"};